import { TabPanel } from '@dai/components'
import { Box, Tab, Tabs } from '@mui/material'
import { Helmet } from 'react-helmet-async'

import StickyHeader from '@/components/StickyHeader'
import { useTabsWithParams } from '@/hooks/use-tabs-with-params'
import useT from '@/i18n/useT'

import InviteUserPage from './InviteUserPage'
import ManageRoles from './ManageRoles'
import UserList from './UserList'

type UserTab = 'users' | 'invites' | 'permissions'

const UserTabMap: Record<UserTab, number> = {
  users: 0,
  invites: 1,
  permissions: 2,
}

const Users = () => {
  const { t } = useT()

  const { sortedTabs, handleChange, value } = useTabsWithParams({
    TabMap: UserTabMap,
    tabs: [
      { key: 'users', label: t('users.tabs.users'), component: <UserList /> },
      {
        key: 'invites',
        label: t('users.tabs.invites'),
        component: <InviteUserPage />,
      },
      {
        key: 'permissions',
        label: t('users.tabs.permissions', 'Roles & Permissions'),
        component: <ManageRoles />,
      },
    ],
  })

  return (
    <>
      <Helmet title={t('users.helmet')} />
      <StickyHeader>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {sortedTabs.map(({ label }, index) => (
              <Tab label={label} id={`tab-${index}`} key={`tab-${index}`} />
            ))}
          </Tabs>
        </Box>
      </StickyHeader>
      {sortedTabs.map(({ component }, index) => (
        <TabPanel value={value} index={index} key={`tab-panel-${index}`}>
          {component}
        </TabPanel>
      ))}
    </>
  )
}

export default Users
